import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router, ActivatedRoute, RouterStateSnapshot } from '@angular/router';
import { SlotsService } from './slots.service';
import { SlotDataService } from './slots-data.service';
import { Observable } from 'rxjs/Observable';
import { SharedService } from '../shared/services/shared.service';
import { AppointmentsService } from '../appointments/appointments.service';
import { EmptyObservable } from 'rxjs/observable/EmptyObservable';

@Injectable()
export class SlotsResolve implements Resolve<any> {

    constructor(private slotsService: SlotsService,
        public slotDataService: SlotDataService,
        private sharedService: SharedService,
        private router: Router
    ) { }

    resolve(route: ActivatedRouteSnapshot) {
        var appointmentCode;
        appointmentCode = route.queryParams.AppointmentCode;
        var user;
        if('type' in route.queryParams){
            route.queryParams.type == '1' ? user = 1 : user = 2;
        }else{
            user = 2;   
        }
        this.slotDataService.setAppointmentCode(appointmentCode);
        return this.slotsService.getAppointmentSlots(1, appointmentCode,user,"",true)
            .catch(e => {
                this.router.navigate(["/error"]);
                this.sharedService.setErrorMessage({ status: e.status, message: e.json().message })
                return Observable.empty<Response>();
            })
    }
}

@Injectable()
export class SlotsRescheduleResolve implements Resolve<any> {

    constructor(private slotsService: SlotsService,
        public slotDataService: SlotDataService,
        private sharedService: SharedService,
        private router: Router
    ) { }

    resolve(route: ActivatedRouteSnapshot) {
        var appointmentCode;
        appointmentCode = route.queryParams.AppointmentCode;
        var user;
        route.queryParams.type == '1' ? user = 1 : user = 2
        this.slotDataService.setAppointmentCode(appointmentCode);
        return this.slotsService.rescheduleAppointment(1, appointmentCode,user,this.slotDataService.timezone,true)
            .catch(e => {
                this.router.navigate(["/error"]);
                this.sharedService.setErrorMessage({ status: e.status, message: e.json().message })
                return Observable.empty<Response>()
            })
    }

}

@Injectable()

export class CustomDomainResolve implements Resolve<any>{


    constructor(
        private appointmentsService: AppointmentsService,
        private sharedService: SharedService,
        private router: Router,
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if(route.queryParams["utm_source"] && route.queryParams["utm_source"] !== ""){
            sessionStorage.setItem('utm_source', route.queryParams["utm_source"]);
        }
        if(route.queryParams["utm_medium"] && route.queryParams["utm_medium"] !== ""){
            sessionStorage.setItem('utm_medium', route.queryParams["utm_medium"]);
        }
        if(route.queryParams["utm_content"] && route.queryParams["utm_content"] !== ""){
            sessionStorage.setItem('utm_content', route.queryParams["utm_content"]);
        }
        if(route.queryParams["utm_campaign"] && route.queryParams["utm_campaign"] !== ""){
            sessionStorage.setItem('utm_campaign', route.queryParams["utm_campaign"]);
        }
        if(route.queryParams["utm_term"] && route.queryParams["utm_term"] !== ""){
            sessionStorage.setItem('utm_term', route.queryParams["utm_term"]);
        }
        
        return this.appointmentsService.getUrlValueByKey(window.location.host,route.params.id,true)
        .catch(e => {
            this.sharedService.errorMessage.message = e ? e.message : 'Something went wrong'
            this.router.navigate(["/error"]);
            return new EmptyObservable<Response>();
        })

    }

}


// WEBPACK FOOTER //
// ./src/app/slots/slots.resolve.ts